"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.detailGallery = void 0;
var DetailGalleryState_1 = require("@/pages/detail/states/DetailGalleryState");
var classNames = require("classnames");
var React = require("react");
var detailGallery = function (props) {
    var onSlidePrevClick = function () { return props.onSlidePrevClick(props.id); };
    var onSlideNextClick = function () { return props.onSlideNextClick(props.id); };
    var onMapViewClick = function () { return props.onMapViewClick(); };
    var onStreetViewClick = function () { return props.onStreetViewClick(); };
    var onViewFloorPlanClick = function () { return props.onViewFloorPlanClick(); };
    var onViewPhotoClick = function () { return props.onViewPhotoClick(); };
    var renderSlides = function (slides, defaultAltText) {
        var renderContent = function (slide, defaultAltText, i) {
            var onSlideClick = function () { return props.onSlideClick(props.id, i, slides[i]); };
            var onSlideLoaded = function (e) {
                var isPortrait = e.currentTarget.naturalWidth < e.currentTarget.naturalHeight;
                props.onSlideLoaded(props.id, i, slides[i], isPortrait);
            };
            var renderSlideCaption = function (text) { return (React.createElement("div", { className: "c-propslider__caption" },
                React.createElement("div", { className: "c-propslider__caption-text" }, text))); };
            if (slide.type === DetailGalleryState_1.DetailGalleryItemType.VIDEO) {
                return (React.createElement("div", { onClick: onSlideClick, className: "c-propslider__slide", key: i },
                    React.createElement("img", { src: slide.thumb }),
                    React.createElement("div", { className: "c-propslider__slide-overlay" },
                        React.createElement("span", { className: "c-propslider__slide-overlay-button" },
                            React.createElement("span", { className: "fas fa-camera-movie" }),
                            React.createElement("span", { className: "c-propslider__slide-overlay-text" }, "Play"))),
                    slide.caption ? renderSlideCaption(slide.caption) : null));
            }
            if (slide.type === DetailGalleryState_1.DetailGalleryItemType.VR) {
                return (React.createElement("div", { onClick: onSlideClick, className: "c-propslider__slide", key: i }, props.showVr ? (React.createElement("iframe", { title: defaultAltText + " - Virtual Tour", style: { pointerEvents: 'none', border: 'none', width: '100%', height: '100%' }, src: slide.src })) : null));
            }
            var imgClass = classNames([
                'c-propslider__slide', {
                    'c-propslider__slide--portrait': slide.isPortrait,
                },
            ]);
            var lazyLoadAttr = i === 0 ? { src: slide.src } : { 'data-src': slide.src };
            return (React.createElement("div", { onClick: onSlideClick, className: imgClass, key: i },
                React.createElement("img", __assign({}, lazyLoadAttr, { loading: 'lazy', onLoad: onSlideLoaded, alt: slide.caption || defaultAltText })),
                slide.caption ? renderSlideCaption(slide.caption) : null));
        };
        return slides.map(function (it, i) { return renderContent(it, defaultAltText, i); });
    };
    var renderThumbs = function (slides, activeIndex, defaultAltText) {
        var renderThumb = function (slide, i, defaultAltText) {
            var onThumbClick = function () { return props.onThumbClick(props.id, i); };
            var classname = classNames([
                'c-propthumb__thumb',
                {
                    'c-propthumb__thumb--active': activeIndex === i,
                },
            ]);
            if (slide.type === DetailGalleryState_1.DetailGalleryItemType.VIDEO) {
                return (React.createElement("div", { className: classname, key: i, onClick: onThumbClick },
                    React.createElement("img", { src: slide.thumb }),
                    React.createElement("div", { className: "c-propthumb__thumbbg" }),
                    React.createElement("div", { className: "c-propthumb__overlay" },
                        React.createElement("span", { className: "fas fa-camera-movie" }),
                        React.createElement("span", { className: "c-propthumb__caption" }, props.t.video))));
            }
            if (slide.type === DetailGalleryState_1.DetailGalleryItemType.VR) {
                return (React.createElement("div", { className: classname, key: i, onClick: onThumbClick },
                    React.createElement("img", { src: slide.thumb, alt: defaultAltText + " - Virtual Tour" }),
                    React.createElement("div", { className: "c-propthumb__thumbbg" }),
                    React.createElement("div", { className: "c-propthumb__overlay" },
                        React.createElement("img", { src: "/res/img/360icon-selected.png", alt: defaultAltText + " - Virtual Tour" }),
                        React.createElement("span", { className: "c-propthumb__caption c-propthumb__caption--vr" }, props.t.virtualTour))));
            }
            return (React.createElement("div", { className: classname, key: i, onClick: onThumbClick },
                React.createElement("img", { src: slide.thumb, alt: slide.caption || '' })));
        };
        return slides.map(function (it, i) { return renderThumb(it, i, defaultAltText); });
    };
    var renderSideIcons = function (props) {
        if (!props.showMapView && !props.showStreetView)
            return '';
        var renderMapViewIcon = function (props) { return (React.createElement("div", { onClick: onMapViewClick, className: "c-propthumb__type" },
            React.createElement("div", { className: "c-propthumb__icon" },
                React.createElement("span", { className: "fas fa-map" })),
            React.createElement("div", { className: "c-propthumb__title" }, props.t.mapView))); };
        var renderStreetViewIcon = function (props) { return (React.createElement("div", { onClick: onStreetViewClick, className: "c-propthumb__type" },
            React.createElement("div", { className: "c-propthumb__icon" },
                React.createElement("span", { className: "fas fa-user" })),
            React.createElement("div", { className: "c-propthumb__title" }, props.t.streetView))); };
        return (React.createElement("div", { className: "c-propthumb__side" },
            props.showMapView ? renderMapViewIcon(props) : '',
            props.showStreetView ? renderStreetViewIcon(props) : ''));
    };
    var renderThumbSection = function (props) {
        return props.showThumbs ? (React.createElement("div", { className: "c-propthumb" },
            React.createElement("div", { className: "c-propthumb__main" },
                React.createElement("div", { onClick: onSlidePrevClick, className: "c-propthumb__arrow" },
                    React.createElement("span", { className: "fal fa-chevron-left" })),
                React.createElement("div", { id: "detailgallery-" + props.id + "-thumbs", className: "c-propthumb__thumbs" }, renderThumbs(props.items, props.currentIndex, props.defaultAltText)),
                React.createElement("div", { onClick: onSlideNextClick, className: "c-propthumb__arrow" },
                    React.createElement("span", { className: "fal fa-chevron-right" }))),
            renderSideIcons(props))) : null;
    };
    var renderOverlay = function (props) {
        var renderLabels = function (props) {
            if (!props.banners)
                return null;
            var renderLabel = function (banner, i) {
                return (React.createElement("span", { key: i, className: "c-propslider__label", style: {
                        backgroundColor: banner.bannerColour,
                        color: banner.labelColour,
                    } }, banner.label.toUpperCase()));
            };
            return (React.createElement("div", { className: "c-propslider__labels" }, props.banners.map(renderLabel)));
        };
        var renderFloorPlanButton = function (props) {
            return props.showFloorPlan ? (React.createElement("a", { onClick: onViewFloorPlanClick, className: "c-propslider__action" },
                React.createElement("span", { className: "fas fa-ruler-combined" }))) : null;
        };
        return (React.createElement("div", { className: "c-propslider__overlay" },
            renderLabels(props),
            React.createElement("div", { className: "c-propslider__more" },
                renderFloorPlanButton(props),
                React.createElement("a", { onClick: onViewPhotoClick, className: "c-propslider__action", href: "#" },
                    React.createElement("span", { className: "far fa-images" }),
                    "\u00A0 ",
                    props.items.length))));
    };
    var rootClass = classNames(['c-propslider', {
            'c-propslider--nothumb': !props.showThumbs,
            'c-propslider--contain': !props.showThumbs,
        }]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: rootClass },
            React.createElement("div", { id: "detailgallery-" + props.id + "-slides", className: "c-propslider__slides" }, renderSlides(props.items, props.defaultAltText)),
            React.createElement("div", { className: "c-propslider__actions" },
                React.createElement("div", { onClick: onSlidePrevClick, className: "c-propslider__arrow c-propslider__arrow--left" },
                    React.createElement("span", { className: "fal fa-chevron-left" })),
                React.createElement("div", { onClick: onSlideNextClick, className: "c-propslider__arrow c-propslider__arrow--right" },
                    React.createElement("span", { className: "fal fa-chevron-right" }))),
            props.showOverlay ? renderOverlay(props) : null),
        renderThumbSection(props)));
};
exports.detailGallery = detailGallery;
